import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
  DropdownItem,
  InputGroup,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  Input,
} from 'reactstrap';

export const SimpleTypeahead = (props) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [inputSearch, setInputSearch] = useState('');

  const toggle = () => setDropdownOpen((prevState) => !prevState);

  const [options, setOptions] = useState(props.options || []);

  useEffect(() => setOptions(props.options), [props.options]);
  useEffect(() => setInputSearch(props.value || ''), [props.value]);

  const getOptions = () => {
    if ((props.alwaysShowOptions || inputSearch !== '') && options?.length) {
      if (_.keys(props.customComponents).includes('Option')) {
        return options.map((opt) =>
          props.customComponents.Option({
            innerProps: {
              className: `type-head-option`,
              onClick: () => {
                toggle();
                props.onChange(opt);
              },
            },
            data: opt,
          })
        );
      }
      return options.map((opt) => (
        <DropdownItem
          className="type-head-option"
          onClick={() => {
            toggle();
            props.onChange(opt);
          }}
          key={opt.id}
          id={opt.id}>
          {opt.label}
        </DropdownItem>
      ));
    }
    return <div className="no-rows-message">No rows</div>;
  };

  const handleChangeInput = (event) => {
    setInputSearch(event.target.value);
    if (props.autoChange) {
      props.onChange(event.target.value);
    }
    if (props.loadOptions) {
      props.loadOptions(event.target.value).then((data) => setOptions(data));
    }
  };

  const isInvalid = () => !props.isValid && inputSearch !== '';

  return (
    <InputGroup
      className={`simple-type-head ${props.disabled ? 'disabled' : ''} ${props.className}`}>
      <Input
        type="text"
        value={inputSearch}
        id={props.id}
        onChange={(event) => handleChangeInput(event)}
        placeholder={props.placeHolder}
        disabled={props.disabled}
        onClick={toggle}
        invalid={isInvalid()}
        autoComplete="off"
      />
      <Dropdown
        addonType="append"
        isOpen={dropdownOpen}
        toggle={toggle}
        disabled={props.disabled}>
        <DropdownToggle
          data-toggle="dropdown"
          tag="div"
          disabled={props.disabled}>
          <div className="sort-down-btn">
            <i className="fa-solid fa-sort-down"></i>
          </div>
        </DropdownToggle>
        <DropdownMenu style={{ width: `100%` }}>{getOptions()}</DropdownMenu>
      </Dropdown>
    </InputGroup>
  );
};

SimpleTypeahead.propTypes = {
  loadOptions: PropTypes.func,
  options: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  className: PropTypes.string,
  id: PropTypes.string,
  placeHolder: PropTypes.string,
  customComponents: PropTypes.object || {},
  alwaysShowOptions: PropTypes.bool || false,
  outsideLabel: PropTypes.bool || false,
  disabled: PropTypes.bool || false,
  isValid: PropTypes.bool,
  autoSelect: PropTypes.bool || true,
  autoChange: PropTypes.bool || true,
};

export default SimpleTypeahead;
